import React from 'react';
import { X, GripVertical } from 'lucide-react';
import { motion, Reorder } from 'framer-motion';

const ImagePreview = ({ images, setImages }) => {
    const removeImage = (id) => {
        setImages(images.filter(img => img.id !== id));
    };

    if (images.length === 0) return null;

    return (
        <div className="w-full mt-4">
            <h3 style={{ marginBottom: '1rem' }}>Selected Images ({images.length})</h3>
            <Reorder.Group axis="y" values={images} onReorder={setImages} style={{ listStyle: 'none' }}>
                {images.map((image) => (
                    <Reorder.Item key={image.id} value={image}>
                        <div className="glass-card" style={{
                            padding: '1rem',
                            marginBottom: '0.75rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                            cursor: 'grab'
                        }}>
                            <GripVertical size={20} style={{ color: 'var(--text-muted)' }} />
                            <div style={{
                                width: '60px',
                                height: '60px',
                                borderRadius: '0.5rem',
                                overflow: 'hidden',
                                background: '#f1f5f9'
                            }}>
                                <img
                                    src={image.preview}
                                    alt={image.file.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <p style={{ fontWeight: 500, fontSize: '0.9rem' }}>{image.file.name}</p>
                                <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                                    {(image.file.size / 1024).toFixed(1)} KB
                                </p>
                            </div>
                            <button
                                onClick={() => removeImage(image.id)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: '#ef4444',
                                    padding: '0.5rem',
                                    borderRadius: '0.375rem'
                                }}
                            >
                                <X size={20} />
                            </button>
                        </div>
                    </Reorder.Item>
                ))}
            </Reorder.Group>
        </div>
    );
};

export default ImagePreview;
